import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2115dbf2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "parent-variation-theme"
};
const _hoisted_2 = {
  class: "variation-value"
};
const _hoisted_3 = {
  class: "theme"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.showIcon ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "theme-branch"
  })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, _toDisplayString($props.theme), 1)])]);
}